module.exports = __webpack_public_path__ + "img/icon-esim-detail-copy-dark.42b1da7.svg";